module.exports = __webpack_public_path__ + "static/gallery28-2ca337556c42f574ca9394e5150fe66d.png";